import { useState, useEffect } from "react";

import ImageGridHelper from "../../helpers/ImageGridHelper";
import { deleteIndex } from "../../helpers/JSONTransformations";

const useProductSidebarImages = (product) => {
  const initialState = {
    images: [],
    imagesAreLoading: false
  };
  const [images, setImages] = useState(initialState.images);

  const onAddImage = (newImageUrls) => {
    const newImages = newImageUrls.map((newImageUrl, index) => ({
      url: newImageUrl,
      order: images.length + index
    }));
    setImages(images.concat(newImages));
  };

  const onRemoveImage = (indexToRemove) =>
    setImages(
      deleteIndex(images, indexToRemove).map((image, index) => ({
        ...image,
        order: index
      }))
    );

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setImages(ImageGridHelper.reSort(oldIndex, newIndex, images));
  };

  const [imagesAreLoading, setImagesAreLoading] = useState(
    initialState.imagesAreLoading
  );

  useEffect(() => {
    setImages(
      product && product.images
        ? product.images
            .slice(1)
            .map((image) => ({ ...image, order: image.order - 1 }))
        : []
    );
  }, [product]);

  const resetState = () => {
    setImages(initialState.images);
    setImagesAreLoading(initialState.setImagesAreLoading);
  };

  return {
    images,
    imagesAreLoading,
    setImagesAreLoading,
    onAddImage,
    onRemoveImage,
    onSortEnd,

    resetState
  };
};

export default useProductSidebarImages;
